import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './Store/store'
import 'bootstrap/dist/css/bootstrap.min.css'

import './index.css'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import $ from 'jquery'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
)
